export default __webpack_public_path__ + "static/img-app-pension--mobile-095c544c2b3510a7e3b430b8ec907a08.png";